import React from 'react';
import { Param as ParamType, Command } from '../../cliDataSchema';
import BooleanOption from './BooleanOption';
import Choice from './ChoiceOption';
import IntOption from './IntOption';
import TextOption from './TextOption';
import UnknownParam from './UnknownParam';
import PathArgument from './PathArgument';
import { FormInstance } from 'antd';
import SonarAndSynopsysSelection from './SonarAndSynopsysSelection';
import RemoteRefSelect from './RemoteRefSelectProps';
import RemoteRefInput from './RemoteRefInput';
import RemoteProjectVersion from './RemoteProjectVersion';
import RemoteProjectLicenseSelection from './RemoteProjectLicenseSelection';
import OSEPPipelines from './OSEPPipelines';

type Props = {
  param: ParamType;
  visibleParams: ParamType[];
  form: FormInstance;
  command?: Command;
};

const Param: React.FC<Props> = ({ param, visibleParams, form, command }) => {
  switch (param.type.param_type) {
    case 'Bool':
      return <BooleanOption param={param} visibleParams={visibleParams} />;
    case 'Choice':
      return <Choice param={param} visibleParams={visibleParams} />;
    case 'String':
      if (
        param.name === 'osep_pipeline_variables' ||
        param.name === 'osep_pipeline_git_reference'
      ) {
        return (
          <OSEPPipelines
            param={param}
            visibleParams={visibleParams}
            form={form}
            command={command}
          />
        );
      }
      if (
        param.name === 'sonar_scan_namespace' ||
        param.name === 'synopsys_detect_namespace'
      ) {
        return (
          <SonarAndSynopsysSelection
            selectedValue={form.getFieldValue(param.name)}
            handleSelectChange={(value) =>
              form.setFieldsValue({ [param.name]: value })
            }
            param={param}
            visibleParams={visibleParams}
          />
        );
      } else if (
        param.osep_generator_ui_display_name === 'Remote Project Version' &&
        param.name === 'version'
      ) {
        return (
          <RemoteProjectVersion
            value={form.getFieldValue(param.name)}
            handleChange={(e) =>
              form.setFieldsValue({ [param.name]: e.target.value })
            }
            param={param}
            form={form}
          />
        );
      } else if (
        param.name === 'remote_ref' ||
        param.name === 'external_project_url'
      ) {
        return (
          <>
            {param.name === 'external_project_url' && (
              <RemoteRefInput
                value={form.getFieldValue(param.name)}
                handleChange={(e) =>
                  form.setFieldsValue({ [param.name]: e.target.value })
                }
                param={param}
                form={form}
              />
            )}
            {param.name === 'remote_ref' && (
              <RemoteRefSelect
                form={form}
                handleSelectChange={(value) =>
                  form.setFieldsValue({ [param.name]: value })
                }
                param={param}
                visibleParams={visibleParams}
              />
            )}
          </>
        );
      } else if (param.name === 'license') {
        return (
          <RemoteProjectLicenseSelection
            selectedValue={form.getFieldValue(param.name)}
            handleSelectChange={(value) =>
              form.setFieldsValue({ [param.name]: value })
            }
            param={param}
            visibleParams={visibleParams}
          />
        );
      }
      return <TextOption param={param} visibleParams={visibleParams} />;

    case 'Path':
      return <PathArgument param={param} visibleParams={visibleParams} />;
    case 'Int':
      return <IntOption param={param} visibleParams={visibleParams} />;
    default:
      return <UnknownParam param={param} />;
  }
};

export default Param;
